import React from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import Step from "../components/Step";
import TranslatedFormGroup from "../components/FormGroup";
import Sidebar from "./StandardSidebar";
import StepFooter from "../components/StepFooter";
import { INPUT_NAMES } from "../utils/config";
import { isValid } from "../utils/validation";

const EmailStep = ({
	t,
	label,
	changeHandler,
	submitHandler,
	inputs,
	errors,
	processing,
	errMsg,
}) => (
	<div className="step container p-0 d-flex flex-md-row flex-column">
		<form className="d-flex flex-column" onSubmit={submitHandler} noValidate>
			<p className="h5 mb-3">{t("emailTitle")}</p>
			<TranslatedFormGroup
				valid={isValid(errors[INPUT_NAMES.email])}
				feedback={errors[INPUT_NAMES.email]}
				label={label}
			>
				<input
					onChange={changeHandler}
					className="form-control"
					type="email"
					name={INPUT_NAMES.email}
					value={inputs[INPUT_NAMES.email]}
					maxLength="255"
					autoFocus
					required
				/>
			</TranslatedFormGroup>
			{errMsg && <div className="alert alert-danger">{errMsg}</div>}
			<button
				className="my-4 btn btn-primary btn-block btn-lg"
				type="submit"
				disabled={processing}
			>
				{t("labels.getStarted")}
			</button>
			<StepFooter loginUrl={window.location.href == "https://signup.uk.damstralearning.com/" ? "https://app.uk.damstralearning.com/" : window.location.href == "https://signup.us.damstralearning.com/" ? "https://app.us.damstralearning.com/" : window.location.href == "https://qa-signup.velpic.com/" ? "https://qa-app.velpic.com/" : "https://app.velpic.com/"} className="mt-auto text-center" />
		</form>
		<Sidebar />
	</div>
);

EmailStep.propTypes = {
	t: PropTypes.func,
	label: PropTypes.string,
	inputs: PropTypes.object,
	errors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	changeHandler: PropTypes.func,
	submitHandler: PropTypes.func,
	processing: PropTypes.bool,
	errMsg: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

EmailStep.defaultProps = {
	label: "labels.email",
};

export default translate()(Step(EmailStep, { [INPUT_NAMES.email]: "" }));



// WEBPACK FOOTER //
// ./src/steps/EmailStep.js